// this file origin from Winningtemp.Shared

import React from "react";
import PropTypes from "prop-types";
import ContentWrapper from "Controls/ContentWrapper";
import Text from "Controls/Text";
import Colors from "Colors";

const AlertComponent = (props) => {
    let styles = {
        borderRadius: "3px",
        padding: "15px",
        fontSize: "14px"
    };

    switch (true) {
        case props.warning:
            styles = {
                ...styles,
                color: Colors.notificationTextBrown,
                backgroundColor: Colors.notificationBackgroundBeige,
                border: `1px solid ${Colors.notificationBorderBeige}`
            };
            break;
        case props.danger:
            styles = {
                ...styles,
                color: Colors.alertDangerText,
                backgroundColor: Colors.alertDangerBackground,
                border: `1px solid ${Colors.alertDangerBorder}`
            };
            break;
        default:
            styles = {
                ...styles,
                color: Colors.alertSuccessText,
                backgroundColor: Colors.alertSuccessBackground,
                border: `1px solid ${Colors.alertSuccessBorder}`
            };
            break;
    }

    return (
        <ContentWrapper {...styles} {...props}>
            <Text color="inherit" fontSize="inherit">{props.text}</Text>
        </ContentWrapper>
    );
}

AlertComponent.propTypes = {
    text: PropTypes.string
}

export default AlertComponent;